import React, { useEffect, useState } from 'react';
import ReactHtmlParser from 'react-html-parser';
import {Pages} from '../../constants/actionType'
import { updateSCTags } from '../../service/dtmTag';
import { updateDetailValue } from '../../service/vzdl';
import { BroadbandLabel } from "@plans/tiles";
import '../../../src/assets/ak-cached/24h/css/fccLabel.css'
import Button from '../../components/button';
import { utils, writeFile } from 'xlsx';
// import * as XLSX from 'xlsx';
import { Modal, ModalBody, ModalFooter, ModalTitle } from "@vds/modals";
import { TextLink } from '@vds/buttons';
import QRCode from "react-qr-code";
import { apiUrl } from './../../constants/apiUrl';
import api from './../../service/apiService';
import { Input } from '@vds/inputs';
// import FiosButton from '../../components/button';
import './fccLabel.css';
import { InHomeUtils } from './../../util/inhomeUtils';

const fccLabel = props => {
    const month = String(new Date().getMonth() + 1).padStart(2, '0')
    const day = String(new Date().getDate()).padStart(2, '0');
    const formattedDate = `${month}/${day}/${new Date().getFullYear()}`
    const { internetData, fccPlanData: initialFccplans, lqData, signIn, fccGrandFatheredPlan, flowType } = props;
    const [isfccPlanData, setIsfccPlanData] = useState([]);
    const [isPopupWindowOpne, setIsPopupWindowOpne] = useState(false);
    const [popupWindowOpneURL, setPopupWindowURL] = useState("");
    const [nonVZLink, setNonVZLink] = useState(false);
    const [mtnValue, setMTN] = useState("");
    const [isMTNvalid, setMTNvalid] = useState(false);
    const [isSendButtonClicked, setSendButtonClicked] = useState(false);
    const [presentDate, setPresentDate] = useState(formattedDate);
    const [isQRModalOpen, setQRModalOpen] = useState(false);
    const [qrCodeURL, setQRCodeURL] = useState("");
    const [dobErr,setDobErr] = useState(false);
    const [dobErrtext,setDobErrtext] = useState('');
    const [fccPlanData,setFccPlanData] = useState(initialFccplans);
    if(fccPlanData !== undefined && fccPlanData !== null && initialFccplans !== undefined && initialFccplans !== null && fccPlanData.length === 0 && initialFccplans.length !== 0){
        setFccPlanData(initialFccplans)
    }
    const showInternalPage = InHomeUtils.getCookie('isFCCInternalPage', document.cookie);
    let sheetData = [];

    useEffect(() => {
        if(fccPlanData && fccPlanData.length > 0) {
            setTimeout(() => {
                if (fccGrandFatheredPlan && fccGrandFatheredPlan.length>0) {
                    const sortFccData =  [...fccPlanData,fccGrandFatheredPlan?.[0]].sort((a, b) => a.planCode.localeCompare(b.planCode));
                    setIsfccPlanData(sortFccData);
                }
                else {
                    const sortFccData =  [...fccPlanData].sort((a, b) => a.planCode.localeCompare(b.planCode));
                    setIsfccPlanData(sortFccData);
                }
            }, 1000)
        } else{
            //console.log('fccPlanData missed')
        }
    }, [fccPlanData, fccGrandFatheredPlan])

    useEffect(() => {
        hideHyperLink();
    }, [])

    const hideHyperLink = () => {
        const isFiOSFlag = sessionStorage?.getItem('fiosReferralFlow');
        const isIframeVisible = sessionStorage?.getItem('isHyperlinkRemoved');
        if (isFiOSFlag && isIframeVisible?.toLowerCase?.() === 'true') {
            let myFunction = (event) => {
                event.preventDefault();
                const href = event.target.href;
                if (href && href?.indexOf("verizon.com") !== -1){
                    if(href?.indexOf("inhome/buildproducts") !== -1) {
                        return;
                    }
                    setPopupWindowURL(href);
                    setIsPopupWindowOpne(true);
                    openiFrame(href);
                } else if(href !== undefined) {
                    if(href?.indexOf("inhome/buildproducts") !== -1) {
                        return;
                    }
                    //setNonVZLink(true);
                    //setIsPopupWindowOpne(true);
                    //setPopupWindowURL("");
                    setQRModalOpen(true);
                    setQRCodeURL(href);
                    generateQRCode(href);
                }
            }
            window?.addEventListener("click", myFunction);
        }
    }

    const closeModal = () => {
        setIsPopupWindowOpne(false);
        setPopupWindowURL("");
        setSendButtonClicked(false);
        setNonVZLink(false);
        setMTN("");
        setMTNvalid(false);
        setQRModalOpen(false);
        setQRCodeURL("");
    }

    const generateQRCode = (nonVZLink) => {
        //console.log("nonVZLink ===>", nonVZLink);
    }

    const openiFrame = (url) => {
        var iframe = document.createElement('iframe');
        iframe.id = 'iframe-page-content'
        iframe.src = url;
        document.getElementById("iframe-content").appendChild(iframe);
        //const iframeElem = document.getElementById('iframe-content');
        const iframeElem = document.getElementById('iframe-page-content');
        const handleIframeLinkClick = () => {
            const iFrameDocument = iframeElem?.contentDocument || iframeElem?.contentWindow?.document;
            if(iFrameDocument){
                iFrameDocument.querySelectorAll('a').forEach(link => {
                    link.removeAttribute('target');
                    link?.addEventListener('click', (e) => {
                        e.preventDefault();
                        const href = e.target.href;
                        if(href &&  href?.indexOf("verizon.com") !== -1){
                            // setPopupWindowURL(href);
                            // setIsPopupWindowOpne(true);
                            // openiFrame(href);
                            // setNonVZLink(false);
                            iframeElem.src = link.href;
                        } else if(href !== undefined) {
                            // setNonVZLink(true);
                            // setIsPopupWindowOpne(true);
                            // setPopupWindowURL("");
                            setQRModalOpen(true);
                            setQRCodeURL(href);
                        } 
                    })
                })
            }
        }

        setInterval(() => {
            if(iframeElem != undefined && iframeElem != null) {
                const iFrameDocument = document.getElementById('iframe-content');
                if(iFrameDocument){
                    handleIframeLinkClick();
                }
            }
        }, 300)
    }

    const getSMSLinkForm = () => {
        return(
            <>
            <div className="ForgetMONCallBack">
                <div classname="resumeinput">
                    <Input
                        type="text"
                        autocomplete="none"
                        aria-autocomplete="none"
                        className={`clear-input text-black`}
                        label="We can send this link to mobile phone number."
                        readOnly={false}
                        required={true}
                        disabled={false}
                        id="emailMTNWhenSaved"
                        autoFocus={true}
                        onChange={(e) => validateNum(e)}
                        value={mtnValue}
                        error={false}
                        errorText={""}
                    />
                </div>
                {isSendButtonClicked && 
                <div role="alert">
                    <div class="ErrorTextWrapper-VDS__sc-13aeuon-0 taZQn">
                        {mtnValue === "" && <p aria-hidden="false" class="error_text">
                            You must enter a Mobile number
                        </p>}
                        {isMTNvalid && <p aria-hidden="false" class="error_text">
                            Please enter a valid phone number
                        </p>}
                    </div>
                </div>}
                <Button 
                    buttonStyle="button medium-p-auto text-center margin-top-large" 
                    id="btnEmailMTNContinue" 
                    type="button" 
                    buttonText="Send" 
                    onClick={sendMyCartNbr} 
                    />
            </div>
            </>
        )
    }

    const validateNum = (e) => {
        setMTN(e.target.value);
        setMTNvalid(false)
    }

    const sendMyCartNbr = () => {
        setSendButtonClicked(true)
        updateSCTags("send me my cart number");
        let patternForMTN = /^\d{3}-\d{3}-\d{4}$/;
        let isMTN = false;
        let isValidMTN = false;
        let cardNum = mtnValue;

        if (cardNum !== '') {
            isMTN = !isNaN(cardNum.substring(0, cardNum.length));
            if (!isMTN && cardNum.indexOf("-") > -1 && !patternForMTN.test(cardNum)) {
                let mtnFormat = cardNum;
                mtnFormat = mtnFormat.replaceAll("-", "").trim();
                isMTN = !isNaN(mtnFormat.substring(0, mtnFormat.length));
                if (isMTN) {
                    isValidMTN = false;
                }
            }
            else if (!isMTN && cardNum.indexOf("-") > -1 && patternForMTN.test(cardNum) && cardNum.length == 12) {
                isMTN = true;
                isValidMTN = true;
            }
            else if (isMTN && cardNum.length == 10) {
                isValidMTN = true;
            }
            else {
                isValidMTN = false;
            }
        }

        if (cardNum === "") {   //WHEN FIELD IS EMPTY
            setMTN("");
        }
        else if (!isMTN && !isValidMTN) { //WHEN PHONE NUMBER NOT ENTERED AND ENTERED BUT NOT VALID
            setMTNvalid(true);
        }
        else if (isMTN && !isValidMTN) { //WHEN PHONE ENTERED BUT NOT VALID
            setMTNvalid(true)
        }
        else {    //WHEN BOTH VALID
            setMTNvalid(false)
        }
        
    }

    const NYData = [{
            label: 'Provider Monthly Fees',
            level: 'l1',
            value: ''
        },
        {
            label: 'NY Municipal Construction Surcharge',
            level: 'l2',
            value: '$2.49'
    }]
    const scrollToTop = (element)=>{
        updateSCTags("back to top");
        let goToTop = document.getElementById(element);
        goToTop?.scrollIntoView({behavior: "smooth"})
    }
    const scrollToPlan = (isoc, planName = '')=>{
        if(planName)
            updateSCTags("Fios " +planName+ " broadband facts");
        let goToPlan = document.getElementById("broadbandfacts_"+isoc);
        goToPlan?.scrollIntoView({behavior: "smooth"})
    }
    let pathName=window.location.pathname
    const scrollBackToTop =()=>{
        let focusElem = document.getElementById("focus2")
        setTimeout(()=>{
            if(pathName !== "/inhome/popularPlans") {
                focusElem.focus()
            } 
        },1000)
        if(pathName==="/inhome/streamlineordering"){
            scrollToTop('INTERNET_SECTION')
        }
        else if(pathName==="/inhome/change/buildproducts"){
            scrollToTop('ecAccordion_wrapper_id')
        } else if(pathName === "/inhome/popularPlans"){
            scrollToTop('popular-plan')
        } else {
            scrollToTop('accordion_wrapper_id')
        }       
    }
    const fccSectionSubProps = (subSection)=>{
        let subContent=[];
        if(subSection !== undefined && subSection !== null){
            if(lqData && lqData?.hoaFlowDetails && lqData?.hoaFlowDetails?.isHoaFlow && subSection?.filter(item => item.label === "Auto Pay and Paper-free Billing:").length > 0){
                return;
            }
            if(subSection?.filter(item => item.label === "Provider Monthly Fees").length > 0 && lqData?.selectedState?.state ==="NY" && subSection?.filter(item => item.label === "NY Municipal Construction Surcharge").length == 0){
                subSection.splice(0,1,...NYData);
            }else if(signIn.state === "NY" && subSection?.filter(item => item.label === "Provider Monthly Fees").length > 0 && subSection?.filter(item => item.label === "NY Municipal Construction Surcharge").length == 0){
                subSection.splice(0,1,...NYData);
            }else if(lqData?.checkPDCResFCC?.state === "NY" && subSection?.filter(item => item.label === "Provider Monthly Fees").length > 0 && subSection?.filter(item => item.label === "NY Municipal Construction Surcharge").length == 0){
                subSection.splice(0,1,...NYData);
            }    
        }
            subSection?.map((obj)=>(subContent.push({label:obj.label,level:obj.level,value:obj.value})))
        return subContent
    }
    const fccSectionProps = (item,sections,itemName)=>{
        let content={};
        let findData = sections?.find(el=>el.id === itemName)
        if(findData){
            content.header=findData.header,
            content.headerVal=findData.headerVal
            content.description=ReactHtmlParser(findData.description, {
                transform:(node, index) => {
                    if (node.type === 'tag' && node.name === 'a') {     
                        return <a {...node.attribs} onClick={()=>anchorClickHanlder(item.planName,findData.header)}>{node.children?.[0].data}</a>             
                    }}})
            content.data= fccSectionSubProps(findData.data)
            content.headerPrimitive = findData.header !== "Monthly Price" && "h4"
        }
        return content
    }


    const anchorClickHanlder = (planName = '', sectionName = '')=>{
        let linkTag = '';
        if(sectionName){
            if(sectionName.toLowerCase() == "discounts & bundles"){
                linkTag = 'DB - click here'
            }
            else if(sectionName.toLowerCase() == "affordable connectivity program"){
                linkTag = 'affordableconnectivity.gov'
            }
            else if(sectionName.toLowerCase() == "network management"){
                linkTag = 'read our policy - NM'
            }
            else if(sectionName.toLowerCase() == "privacy"){
                linkTag = 'read our policy:  privacy'
            }
            else if(sectionName.toLowerCase() == "footer"){
                linkTag = 'fcc.gov/consumer'
            }
        }
        updateDetailValue(planName);
        updateSCTags(linkTag);
    }

    const downloadLabel = () => {
        sheetData = [];
        fccPlanData.map((item) =>{
            const sections = item?.sections;
            const monthlyPriceSection = sections.filter((item) => item.id === 'monthlyPrice');
            const additionalChargesSection = sections.filter((item) => item.id === 'additionalCharges');
            const planSpeedSection = sections.filter((item) => item.id === 'speed');
            const dataSection = sections.filter((item) => item.id === 'dataMonthly');
            const IntroductoryPrice = monthlyPriceSection[0].data.filter((subSection) => subSection.label.includes('introductory rate'));
            const IntroductoryPriceDetails = monthlyPriceSection[0].data.filter((subSection) => subSection.label.includes('monthly contract'));
            const DownloadSpeed = planSpeedSection[0].data.filter((subSection) => subSection.label === 'Typical Download Speed');
            const UploadSpeed = planSpeedSection[0].data.filter((subSection) => subSection.label === 'Typical Upload Speed')
            const Latency = planSpeedSection[0].data.filter((subSection) => subSection.label === 'Typical Latency')
            const dataUsage = dataSection[0].data.filter((subSection) => subSection.label == 'Charges for Additional Data Usage')
            const earlyTermination = additionalChargesSection[0].data.filter((subSection) => subSection.label === 'Early Termination Fee');
            const governmentTaxes = additionalChargesSection[0].data.filter((subSection) => subSection.label === 'Government Taxes');
            let oneTimeFee = additionalChargesSection[0].data.filter((subSection) => subSection.level === "l2").map((item) =>{
                return `\n- ${item.label} : ${item.value}`
            });
            let oneTimeFeeStr = '';
            let i = lqData?.selectedState?.state ==="NY" || signIn?.state === "NY" || lqData?.checkPDCResFCC?.state === "NY" ? 1 : 0;
            for(i;i<oneTimeFee.length;i++){
                oneTimeFeeStr += oneTimeFee[i];
            }
            if(showInternalPage){
                sheetData.push({
                    'PROVIDER NAME': item?.providerName || 'none',
                    'LABEL PLAN NAME': item?.planName || 'none',
                    "TYPE": item?.type || 'none',
                    "MONTHLY PRICE" : monthlyPriceSection[0].headerVal || '',
                    "INTRODUCTORY PRICE" : IntroductoryPrice[0]?.label || '',
                    "INTRODUCTORY PRICE DETAILS" : IntroductoryPrice[0]?.value || 'N/A',
                    "MONTHLY PRICE CONTRACT" : IntroductoryPriceDetails[0]?.label || '',
                    "MONTHLY PRICE CONTRACT DURATION" : IntroductoryPriceDetails[0]?.value || "N/A",
                    "PROVIDER MONTHLY FEES" : lqData?.selectedState?.state ==="NY" || signIn?.state === "NY" || lqData?.checkPDCResFCC?.state === "NY" ? `- NY Municipal Construction Surcharge : $2.49
                    ` : 'None',
                    "ONE-TIME FEES AT THE TIME OF PURCHASE" : oneTimeFeeStr || '',
                    "EARLY TERMINATION FEE" : earlyTermination[0]?.value || '',
                    "GOVERNMENT TAXES" : governmentTaxes[0]?.value || '',
                    "DISCOUNTS & BUNDLES" : 'https://www.verizon.com/discounts/',
                    "SPEED - DOWNLOAD" : DownloadSpeed[0]?.value || '',
                    "SPEED - UPLOAD" : UploadSpeed[0]?.value || '',
                    "SPEED - LATENCY" : Latency[0]?.value || '',
                    "DATA INCLUDED WITH MONTHLY PRICE" : dataSection[0]?.headerVal || '',
                    "DATA INCLUDED LINK" : 'None',
                    "CHARGES FOR ADDITIONAL DATA USAGE" : dataUsage[0].value || '',
                    "NETWORK MANAGEMENT LINK" : 'https://www.verizon.com/about/our-company/network-management',
                    "PRIVACY LINK" : 'https://www.verizon.com/about/privacy/fios-privacy-policy',
                    "CUSTOMER SUPPORT" : 'https://www.verizon.com/support/contact-us',
                    "UNIQUE PLAN IDENTIFIER" : item.planId || '',
                    'DATE' :  presentDate ,
                    'ADDRESS' : `${lqData?.checkPDCResFCC?.adr1} ${lqData?.checkPDCResFCC?.zip}`,
                })    
            }else{
                sheetData.push({
                    'PROVIDER NAME': item?.providerName || 'none',
                    'LABEL PLAN NAME': item?.planName || 'none',
                    "TYPE": item?.type || 'none',
                    "MONTHLY PRICE" : monthlyPriceSection[0].headerVal || '',
                    "INTRODUCTORY PRICE" : IntroductoryPrice[0]?.label || '',
                    "INTRODUCTORY PRICE DETAILS" : IntroductoryPrice[0]?.value || 'N/A',
                    "MONTHLY PRICE CONTRACT" : IntroductoryPriceDetails[0]?.label || '',
                    "MONTHLY PRICE CONTRACT DURATION" : IntroductoryPriceDetails[0]?.value || "N/A",
                    "PROVIDER MONTHLY FEES" : lqData?.selectedState?.state ==="NY" || signIn?.state === "NY" || lqData?.checkPDCResFCC?.state === "NY" ? `- NY Municipal Construction Surcharge : $2.49
                    ` : 'None',
                    "ONE-TIME FEES AT THE TIME OF PURCHASE" : oneTimeFeeStr || '',
                    "EARLY TERMINATION FEE" : earlyTermination[0]?.value || '',
                    "GOVERNMENT TAXES" : governmentTaxes[0]?.value || '',
                    "DISCOUNTS & BUNDLES" : 'https://www.verizon.com/discounts/',
                    "SPEED - DOWNLOAD" : DownloadSpeed[0]?.value || '',
                    "SPEED - UPLOAD" : UploadSpeed[0]?.value || '',
                    "SPEED - LATENCY" : Latency[0]?.value || '',
                    "DATA INCLUDED WITH MONTHLY PRICE" : dataSection[0]?.headerVal || '',
                    "DATA INCLUDED LINK" : 'None',
                    "CHARGES FOR ADDITIONAL DATA USAGE" : dataUsage[0].value || '',
                    "NETWORK MANAGEMENT LINK" : 'https://www.verizon.com/about/our-company/network-management',
                    "PRIVACY LINK" : 'https://www.verizon.com/about/privacy/fios-privacy-policy',
                    "CUSTOMER SUPPORT" : 'https://www.verizon.com/support/contact-us',
                    "UNIQUE PLAN IDENTIFIER" : item.planId || '',
                })    
            }
        });    
        const wb = utils.book_new();
        const ws = utils.json_to_sheet(sheetData);
        ws['!cols'] = [{ wch: 10 }];
        utils.book_append_sheet(wb, ws, 'Mysheet');
        writeFile(wb, 'Broadband facts.xlsx');
    }

    let lqEditAddress = false;
    lqEditAddress = lqData && lqData.runtimeKey && lqData.runtimeKey.LqEditAddress && lqData.runtimeKey.LqEditAddress === "Y" ? true : false;

    const saveDate = (e) => {
        // console.log(e, "date saved")
        // console.log(presentDate, "handle")
    }

    const handleDateChange = (e) => {
        let input = e.target.value;
        let value = input.replace(/\D/g, '');
        let formattedValue = ''
        if(value.length > 2){
            formattedValue += value.substring(0,2) + '/'
            if(value.length > 4){
                formattedValue += value.substring(2,4) + '/'
                formattedValue += value.substring(4,8)
            }else{
                formattedValue += value.substring(2,4)   
            }
        }else{
            formattedValue += value   
        }
        setPresentDate(formattedValue)
    }
    return (
            <div>
                {pathName === '/inhome/fccbroadbandlabels'? 
                    <div className="fccmainContainer">
                       <div className="fccAdd">
                        <div>
                           <h6 className="fccLearnAddHead">Your address:</h6>
                           <div style={{ display: 'flex' , columnGap:'4px'}} classname="fccLearn">
                                 {`${lqData?.checkPDCResFCC?.adr1} ${lqData?.checkPDCResFCC?.zip}`}
                            </div>
                        </div>
                        <div className="fccEdit">
                            {lqEditAddress && <p style={{ marginBottom:'unset'}} > <div style={{ color:'black'}}> <a className="EditAddress"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        window.location.href = Pages.fccLearnUrl
                                    }}
                                    aria-label={`See Details for`} role="link"
                                    tabIndex="0" style={{ textDecoration: 'underline', color:'black'}} id={`EditAddress`}><span className="screen-reader-only"></span>Edit
                                </a></div></p>}
                        </div>
                    </div>
                    {/* for date  */}
                    {showInternalPage ?
                                        <div >
                                        <div>
                                            <h6 className="fccLearnAddHead">Date:</h6>
                                            <div style={{ display: 'flex', columnGap: '4px' }} classname="fccLearn">
                                                {presentDate}
                                                <Modal toggleButton={
                                                    <TextLink role="button">Edit</TextLink>
                                                }
                                                    fullScreenDialog={false}
                                                >
                                                    <ModalTitle>
                                                        Edit Date
                                                    </ModalTitle>
                                                    <ModalBody>
                                                        <Input
                                                            type="date"
                                                            label="Date"
                                                            dateFormat="mm/dd/yyyy"
                                                            readOnly={false}
                                                            required={true}
                                                            disabled={false}
                                                            error={dobErr}
                                                            errorText={dobErrtext}
                                                            value={presentDate}
                                                            onChange={handleDateChange}
                
                                                        />
                                                    </ModalBody>
                                                    <ModalFooter
                                                        buttonData={{
                                                            primary: {
                                                                children: "Save",
                                                                onClick: (e) => {
                                                                    const [month,day,year] = presentDate.split('/');
                                                                    const convertedDate = `${year}-${month}-${day}`
                                                                    let isocInfo = props.internetData.map((item) => item.id)
                                                                    const url = apiUrl().getFccLabel +  '?DateCode='+convertedDate;
                                                                    return new Promise((resolve) => {
                                                                        api(url, 'GET', '').then((response) => {
                                                                         let isocData=[]
                                                                         response.plans?.filter((item)=>{
                                                                            isocData.push(item);
                                                                        })
                                                                        if(isocData.length !== 0){
                                                                            setDobErr(false);
                                                                            setDobErrtext("")
                                                                            setFccPlanData(isocData);
                                                                        }else{
                                                                            setDobErr(true);
                                                                            setDobErrtext("No record found")
                                                                        }
                                                                        setTimeout(()=> {
                                                                        },5000)
                                                                          dispatch({ type: 'FCC_LABEL_INFO', value: isocData});
                                                                          resolve(true);
                                                                        })
                                                                        .catch((error) => {
                                                                          const errorMsg = `MethodName:FCCLabelData,errorMessage:${error.message}`;
                                                                          resolve(true);
                                                                        });
                                                                    });                                            
                                                                }
                                                            },
                                                            close: {
                                                                children: "Close"
                                                            }
                                                        }}
                                                    />
                                                </Modal>
                
                                            </div>
                                        </div>
                
                                    </div>
                : ''}
                </div>
                : ''}
                {fccPlanData && fccPlanData.length > 0 &&
                <div className={`${pathName === "/inhome/fccbroadbandlabels" ? 'fccLearnHeader' : `${flowType == 'SUPP' ? 'supp_broadbandFacts_spacing' : 'margin-top-xlarge'}`}`}>
                    {
                        pathName === '/inhome/fccbroadbandlabels'?
                        <div>
                            <div className="fccLearnMainHeader">
                               <h3 style={{marginBottom:'0px'}}>Home Internet plans-</h3>
                               <h3 style={{marginTop:'0px'}}>broadband facts labels</h3>
                            </div>
                            <div className="padding-top-small padding-bottom-medium" style={{width:"340px"}}>      
                                <Button class='downloadBtn' buttonText="Download broadband labels" onClick={downloadLabel} buttonStyle={"button text-center"} />
                            </div>
                        </div>: <h2  className={`${"fccHead"} ${"homeBrodadBanFactsLabel"}` && pathName==="/inhome/popularPlans" ? 'broadbandFactsPopularPlan' : 'broadbandFactsBuildproducts' }  style={{fontSize: "1.5rem", marginBottom: "0px"}}>Home broadband facts</h2>
                    }
                    <p className={`${"fccPara margin-bottom-tiny"} ${"homeBrodadBanFactsLabel"}` && pathName==="/inhome/popularPlans" ? 'broadbandFactsPopularPlan' : 'broadbandFactsBuildproducts'} >Prices do not reflect Auto Pay discounts, other discounts or perks.</p>
                 
                   {pathName==='/inhome/change/pegarecommendation'?
                   <a className="fccBackToTop text-black mm3-text-small margin-bottom-tiny" style={{textDecoration:'underline'}} onClick={()=>scrollToTop('vz-gh20')}>Back to top</a>:''}
                </div>
                }
                {
                    pathName==="inhome/change/pegarecommendation"? fccPlanData && fccPlanData?.length > 0 && window.screen.width < 500 && fccPlanData?.map((item)=>{
                        return(<div onClick={()=>scrollToPlan(item?.planCode, item?.planName)}><a className="text-black"  style={{textDecoration:"underline"}}>{item?.planName}</a></div>)
                    })
                //     :pathName !== '/inhome/fccbroadbandlabels'? fccPlanData && fccPlanData.length > 0 && window.screen.width < 500 && internetData?.map((item)=>{
                //     return(<div onClick={()=>scrollToPlan(item.bundleKey, item.name)}><a className="text-black"  style={{textDecoration:"underline"}}>Fios {item.name} broadband facts</a></div>)
                // })
                :''}
                 {window.screen.width < 500 && pathName!="/inhome/pegarecommendation" && pathName!="/inhome/fccbroadbandlabels"&&                        
                    <div className="padding-top-tiny text-left">
            <a className=" text-black mm3-text-small" style={{textDecoration:'underline'}} onClick={()=>{scrollBackToTop()}}>Back to top</a>
        </div>}
        {/* old fcc broadbandlabel code */}
                {/* {
                fccPlanData?.map((item)=>{ 
                        return(
                            <div>
                                <div className="fccBlock" id={`broadbandfacts_${item.planCode}`}>                     
                                    <h3 className='fccMainHeader marigin-top-tiny margin-bottom-tiny' id="item-header" style={{textAlign:"center"}}>{item.header}</h3>    
                                    <Line type="light" className="margin-horiz-micro"/>
                                    <div >
                                        <h4 className='Fccheader margin-top-zero'>Verizon</h4>
                                        <p className='fccSubHeader margin-top-zero'>{item.planName}</p>
                                        <p className="fccSubSubHeader">Fixed Broadband Consumer Disclosure</p>
                                    </div>
                                    {
                                        item?.sections?.map((val)=>{
                                            return(
                                                <div>                                      
                                                    <div>
                                                        {val.header?.includes("Monthly Price") && val.headerVal?.includes("$")?<Line className="mainLine margin-horiz-micro" />:''}
                                                        <div className='fccHeaderDes'>                      
                                                            { 
                                                            (val.header)?.includes('Network Management')?
                                                                <div className="fccDescription margin-bottom-tiny">
                                                                    <h4 className="fccHeaderVal">{val.header}</h4>
                                                                    <div className="fccHeaderNetMgtDes">{ReactHtmlParser(val.description, {
                                                                        transform:(node, index) => {
                                                                            if (node.type === 'tag' && node.name === 'a') {     
                                                                                return <a {...node.attribs} onClick={()=>anchorClickHanlder(item.planName,val.header)}>{node.children?.[0].data}</a>             
                                                                            }
                                                                        }
                                                                    })}</div>   
                                                                </div>  : 
                                                                (val.header)?.includes('Privacy')? 
                                                                <div className="fccDescription">
                                                                    <h4 className="fccHeaderVal">{val.header}</h4>
                                                                    <div className="fccHeaderPrivacyDes">{ReactHtmlParser(val.description, {
                                                                        transform:(node, index) => {
                                                                            if (node.type === 'tag' && node.name === 'a') {     
                                                                                return <a {...node.attribs} onClick={()=>anchorClickHanlder(item.planName,val.header)}>{node.children?.[0].data}</a>             
                                                                            }
                                                                        }
                                                                    })}</div>   
                                                                </div>:
                                                                <h4 className="fccHeaderVal">{val.header}</h4>                                                                                                                      
                                                            }
                                                            <div className="fccPrice">{val.headerVal}</div>                                 
                                                        </div>   
                                                        {val.headerVal?.includes('$')?  <Line type="light" className="margin-horiz-micro" />:''}
                                                        {
                                                            (val.header)?.includes("Network Management")? "" :(val.header)?.includes("Privacy")? "":<div className={(val.header==="Customer Support")?"fccCsDes":"fccMainDes"}>{ReactHtmlParser(val.description, {
                                                                transform:(node, index) => {
                                                                    if (node.type === 'tag' && node.name === 'a') {     
                                                                        return <a {...node.attribs} onClick={()=>anchorClickHanlder(item.planName,val.header)} id='focus1'>{node.children?.[0].data}</a>             
                                                                    }
                                                                }
                                                            })}</div>                                                  
                                                        }
                                                        {
                                                            val?.data?.map((key)=>{
                                                                return(
                                                                    <div className={(key.label==="Auto Pay and Paper-free Billing:"?'fccAutoPayNoLab': key.label==="Participates in the ACP"?'fccLabelValue':key.level==="l1"?'fccLabelPrice':key.level==="l2"?'fccLabel':val.header==="Monthly Price"?"fccMp":'fccNoLabel')} style={{justifyContent:'space-between',display:'flex'}}>
                                                                    <div>{key.label}</div>
                                                                  {(key.label==="Provider Monthly Fees" && lqData?.selectedState?.state==="NY")?
                                                                    <div className={(key.label==="Auto Pay and Paper-free Billing:"?'fccNoBoldPrice':'fccPriceValue')}>$2.49</div> : <div className={(key.label==="Auto Pay and Paper-free Billing:"?'fccNoBoldPrice':'fccPriceValue')}>{key.value}</div>}
                                                                    </div>
                                                                )
                                                            })
                                                        }                                       
                                                        {
                                                        (val.header)?.includes('Network Management')?'':  (val.header)?.includes("Privacy")?<Line className="mainLine margin-horiz-micro"/>:(val.header)?.includes("Discounts & Bundles")?<Line type="light" className="margin-horiz-micro"/>:<Line  className="fccMedLine margin-horiz-micro"/>
                                                        }   
                                                    </div>                   
                                                </div>
                                            )
                                        })
                                    }
                                    <div className="fccFooterDes fccFooterLink">{ReactHtmlParser(item.footer,  {
                                        transform:(node, index) => {
                                            if (node.type === 'tag' && node.name === 'a') {     
                                                return <a {...node.attribs} onClick={()=>anchorClickHanlder(item.planName,"footer")}>{node.children?.[0].data}</a>             
                                            }
                                            }
                                        })}
                                    </div>
                                    <div className="fccplanId">{item.planId}</div>
                                </div>
                                {window.screen.width < 500 && pathName!="/inhome/pegarecommendation" && pathName!="/inhome/fccbroadbandlabels"&&                        
                                         <div className="padding-top-tiny text-center">
                                    <a className=" text-black mm3-text-small" style={{textDecoration:'underline'}} onClick={()=>{scrollBackToTop()}}>Back to top</a>
                                </div>}
                                {window.screen.width <500 && pathName === "/inhome/pegarecommendation" ?
                                    <div className="padding-top-tiny text-center">
                                    <a className=" text-black mm3-text-small" style={{textDecoration:'underline'}} onClick={()=>{scrollToTop('vz-gh20')}}>Back to top</a>
                                </div>:""}
                                {window.screen.width< 500 && pathName==="/inhome/fccbroadbandlabels"?
                                    <div className="padding-top-tiny text-center">
                                    <a className=" text-black mm3-text-small" style={{textDecoration:'underline'}} onClick={()=>{scrollToTop('fcc-learn')}}>Back to top</a>
                                </div>:""}
                            </div>
                            
                        )
                    })
                } */}
                 {/* {window.screen.width>500 && fccPlanData && fccPlanData?.length > 0 && pathName != '/inhome/fccbroadbandlabels' && pathName !='/inhome/change/pegarecommendation'?
                <a 
                    className="fccBackToTopBp text-black mm3-text-small margin-bottom-tiny" 
                    style={{textDecoration:'underline',width:"100%"}} 
                    // onClick={()=>scrollBackToTop()} 
                    tabIndex="0" 
                    role='button' 
                    aria-label='Jump to the top of the webpage' 
                    // onKeyDown={()=>scrollBackToTop()}
                    href="#add-your-plan">
                    Back to top</a>
                :""  }  */}
        {/* fcc broadband label with VDS  */}
    {isfccPlanData?.map((item)=>{
            return(
                <>
                <div id='focus1' tabIndex={0} className={pathName==="/inhome/popularPlans" ? 'fccBlock fccBlock-noPdg-noBorder1' : "fccBlock fccBlock-noPdg-noBorder"}>
                <BroadbandLabel 
                header={item.header}
                headerPrimitive={item.header === "Broadband Facts" && "h3"}
                provider={{providerName:item.providerName,planName:item.planName,type:item.type,providerNamePrimitive:item.providerName === "Verizon" && "h4",planNamePrimitive : "h4"}}
                monthlyPrice={fccSectionProps(item,item.sections,"monthlyPrice")} 
                additionalCharges={fccSectionProps(item,item.sections,"additionalCharges")}
                speedsProvided={fccSectionProps(item,item.sections,"speed")}
                discountsAndBundles={fccSectionProps(item,item.sections,"discountsBundles")}
                // ACPParticipation={fccSectionProps(item,item.sections,"acp")} //removed as per product manager reference ticket comments FCCRBL-90
                dataIncluded={fccSectionProps(item,item.sections,"dataMonthly")}
                networkManagementLink={fccSectionProps(item,item.sections,"networkManagement")}
                customerSupport={fccSectionProps(item,item.sections,"customerSupport")}
                privacyLink={fccSectionProps(item,item.sections,"privacy")}
                footer={ReactHtmlParser(item.footer, {
                    transform:(node, index) => {
                        if (node.type === 'tag' && node.name === 'a') {     
                            return <a {...node.attribs} onClick={()=>anchorClickHanlder(item.planName,"footer")}>{node.children?.[0].data}</a>             
                        }}})}
                footnote={item.planId}
                />
                </div>
                {window.screen.width < 500 && pathName!="/inhome/pegarecommendation" && pathName!="/inhome/fccbroadbandlabels"&&                        
                    <div className="padding-top-tiny text-center">
                      <a className=" text-black mm3-text-small" style={{textDecoration:'underline'}} onClick={()=>{scrollBackToTop()}}>Back to top</a>
                     </div>}
                </>
            )})}
            {window.screen.width>500 && fccPlanData && fccPlanData?.length > 0 && pathName != '/inhome/fccbroadbandlabels' && pathName !='/inhome/change/pegarecommendation'?
                <a 
                    className="fccBackToTopBp text-black mm3-text-small margin-bottom-tiny" 
                    style={{textDecoration:'underline',width:"100%"}} 
                    onClick={()=>scrollBackToTop()} 
                    tabIndex="0" 
                    role='button' 
                    aria-label='back to top' 
                    onKeyDown={()=>scrollBackToTop()}
                    href="#add-your-plan">
                    Back to top</a>
                :""  } 
            {isPopupWindowOpne && (popupWindowOpneURL !== "" || nonVZLink) && 
                <div id="modal-overlay">
                    <div class={`modal ${nonVZLink ? "callback_form" : ""}`}>
                        <div>
                            <div class="modal-close-button close-icon" onClick={closeModal}>&times;</div>
                        </div>
                       <div class="modal-content" id="iframe-content">
                            {/* {nonVZLink &&  getSMSLinkForm()} */}
                        </div>
                    </div>
                </div>
            }
            {isQRModalOpen && qrCodeURL !== "" && 
                <div id="modal-overlay">
                    <div class={`modal qr-code`}>
                        <div>
                            <div class="modal-close-button close-icon" onClick={closeModal}>&times;</div>
                        </div>
                       <div class="modal-content" id="qr-code-content">
                            <div className="qr-code-section">
                                <div style={{ height: "auto", margin: "0 auto", maxWidth: 80, width: "100%" }}>
                                    <QRCode
                                        size={256}
                                        style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                                        value={qrCodeURL}
                                        viewBox={`0 0 256 256`}
                                    />
                                </div>
                            </div>
                            <div className="qr-code-text-section">
                                Scan QR Code to access link.
                            </div>
                            <div className="non-verizon-link">
                                <p>{qrCodeURL}</p>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </div>
    )}

export default React.memo(fccLabel);


